import { render } from "./WebSiteBehaviorBehavior.vue?vue&type=template&id=ad806c62&scoped=true"
import script from "./WebSiteBehaviorBehavior.vue?vue&type=script&lang=js"
export * from "./WebSiteBehaviorBehavior.vue?vue&type=script&lang=js"

import "./WebSiteBehaviorBehavior.vue?vue&type=style&index=0&id=ad806c62&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad806c62"]])

export default __exports__